<script setup lang="ts">
const { trackEvent } = useGtm();
const profileStore = useProfileStore();

onMounted(() => {
	trackEvent({
		user_id: profileStore.profileId,
		event: GTM_EVENT_NAME.VIEW_HELP_PAGE_SUCCESS,
	});
});
</script>
<template>
  <div class="page">
    <h1 class="title">
      Let us help with
    </h1>
    <div class="help-menu">
      <a
        href="https://us-help-organizer.peatix.com/"
        target="_blank"
        class="link organizer"
      >
        <div class="icon">
          <UserOrganizerIcon />
        </div>
        <h2 class="link-title text-xl text-semibold">Organizing the event</h2>
      </a>
      <a
        href="https://us-help-attendee.peatix.com/"
        target="_blank"
        class="link"
      >
        <div class="icon">
          <UserAttendeeIcon />
        </div>
        <h2 class="link-title text-xl text-semibold">Attending the event</h2>
      </a>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.page {
    padding-top: spacings-get(12);
    text-align: center;

    @include media-query-max(mobile) {
      padding-top: spacings-get(8);
    }
}

.title {
      @include fonts-get(semibold, display-lg);

      @include media-query-max(mobile) {
          @include fonts-get(semibold, display-md);
      }
  }

.help-menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: spacings-get(4);
  margin-top: spacings-get(10);

  @include media-query-max(mobile) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 spacings-get(4);
  }

  .link {
    display: flex;
    align-items: center;
    padding: spacings-get(6);
    flex-direction: column;
    justify-content: center;
    gap: spacings-get(6);
    height: 100%;
    min-height: rem(320);
    text-align: start;
    box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10);
    @include border-radius-lg;

    .icon {
      display: flex;
      padding: spacings-get(3);
      background-color: colors-get(primary, 100);
      border-color: colors-get(primary, 50);
      border-width: spacings-get(2);
      border-style: solid;
      box-sizing: content-box;
      @include border-radius-rounded;
    }

    .link-title {
      color: colors-get(gray, 900);
    }

    .link-sub-title {
      color: colors-get(gray, 600);
    }
  }
}
</style>